"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var csod = require("player-core");
var constants = require("../../shared/code/Constants");
function view() {
    var _this = this;
    return {
        state: {
            question: this.props.question,
            constants: constants,
            labelId: this.props.question.tag,
            isTMNTApril2021Enabled: csod.viewModel.isTMNTApril2021Enabled
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            _this.view.state.question = nextProps.question;
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onQuestionAnswered: function (value) {
                _this.view.state.question.errorMessage = "";
                _this.props.onQuestionAnswered(_this.view.state.question.id, value);
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowEEOQuestion/View.js
// module id = 735
// module chunks = 0